import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextComponent} from './components/inputs/input-text/input-text.component';
import {InputPasswordComponent} from './components/inputs/input-password/input-password.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {PrimaryButtonComponent} from './components/buttons/primary-button/primary-button.component';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import { HttpClientModule } from '@angular/common/http';
import { PortalModule } from '@angular/cdk/portal';
import { LoginFormComponent } from './components/auth/login-form/login-form.component';
import { ForgotPasswordComponent } from './components/account/forgot-password/forgot-password.component';
import { SignUpComponent } from './components/account/sign-up/sign-up.component';
import { UserAvatarComponent } from './components/account/user-avatar/user-avatar.component';
import { MyButtonComponent } from './components/buttons/my-button/my-button.component';
import { LoginPageComponent } from './components/auth/login-page/login-page.component';
import { NotFoundPageComponent } from './components/error/not-found-page/not-found-page.component';
import { InputDateComponent } from './components/inputs/input-date/input-date.component';
import { InputTimeComponent } from './components/inputs/input-time/input-time.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PortalModule,

    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatTabsModule,
    MatToolbarModule,
    MatSidenavModule,

    InputDateComponent,
    InputTextComponent,
    InputTimeComponent,
    InputPasswordComponent,
    MyButtonComponent,
    PrimaryButtonComponent,

    LoginFormComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    SignUpComponent,
    UserAvatarComponent,

    NotFoundPageComponent,
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PortalModule,

    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatTabsModule,
    MatToolbarModule,
    MatSidenavModule,

    InputDateComponent,
    InputTextComponent,
    InputTimeComponent,
    InputPasswordComponent,
    MyButtonComponent,
    PrimaryButtonComponent,

    LoginFormComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    SignUpComponent,
    UserAvatarComponent,

    NotFoundPageComponent,
  ]
})
export class SharedModule {
}
